import React, { useEffect } from "react";
import { Box, TextField } from "@material-ui/core";
import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";

import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

interface MonthSelectPlugin extends Function {
  new (config: any): any;
}

interface Props {
  label: string;
  type?: string;
  value: any;
  onChange?: any;
  helperText?: any;
  error?: boolean;
  required?: boolean;
  name?: string;
  isReadOnly?: boolean;
  maxDate?: string;
  minDate?: string;
  cssClassName?: string;
  outerCss?: boolean;
  datePickerRef?: any;
  enableTime?: boolean;
}

const CommonTextFieldMonthYear = ({
  label,
  value,
  onChange,
  helperText = "",
  error = false,
  required = false,
  name = "",
  isReadOnly = false,
  maxDate = "",
  minDate = "",
  cssClassName = "",
  outerCss = false,
  datePickerRef,
  enableTime = true,
}: Props) => {
  // const outerContainerRef = useAppSelector(scrollContainerRef);
  const outerContainerRef = document.getElementById("main-scrollable-element");
  useEffect(() => {
    const handleScroll = () => {
      // Hide the calendar when the container is scrolled
      datePickerRef?.current?.flatpickr?.close();
    };
    outerContainerRef?.addEventListener("scroll", handleScroll);
    return () => {
      outerContainerRef?.removeEventListener("scroll", handleScroll);
    };
  }, [outerContainerRef]);

  return (
    <Box style={outerCss ? { position: "relative", top: "10px" } : {}}>
      <TextField
        className={cssClassName}
        disabled={isReadOnly}
        id={name}
        type="text"
        name={name}
        label={label}
        // onChange={onChange}
        // value={value ? moment(value).format("MM/DD/YYYY hh:mm A") : ""} //method#1
        // value={isReadOnly ? moment(value).format("YYYY-MM-DD HH:mm") : ""}
        required={required}
        helperText={helperText}
        error={error}
        variant="outlined"
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        // InputProps={{
        //   endAdornment: (
        //     <InputAdornment position="end">
        //       <IconButton aria-label="calender icon" edge="end" style={{ paddingLeft: 0 }}>
        //         {<CalendarToday />}
        //       </IconButton>
        //     </InputAdornment>
        //   ),
        // }}
        fullWidth
      />
      <Box
        className={isReadOnly ? "flatpickr-outer disabled-flatpickr-outer" : "flatpickr-outer"} //method#2
        style={{
          position: "relative",
          paddingLeft: "4px",
          bottom: "29px",
        }}
      >
        <Flatpickr
          ref={datePickerRef}
          disabled={isReadOnly}
          style={{
            padding: "4.5px 8px",
            borderRadius: "4px",
            border: 0,
            background: "transparent",
            width: "98%",
            // textIndent: "-9999px", //method#1
          }}
          value={value}
          options={{
            allowInput: true,
            minDate: minDate,
            maxDate: maxDate,
            enableTime: enableTime,
            altInput: true,
            altFormat: "m/Y",
            // dateFormat: "Y-m",
            plugins: [
              new (monthSelectPlugin as unknown as MonthSelectPlugin)({
                shorthand: true,
                dateFormat: "m/Y",
                altFormat: "m-Y",
              }),
            ],
          }}
          onChange={(e, v) => {
            onChange && onChange(v);
          }}
        />
      </Box>
    </Box>
  );
};

export default CommonTextFieldMonthYear;
